export enum MassiveSendingContentType {
  Text = 0,
  ImageAndText
}